import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalDetalheGraficoComponent } from '../modal-components/modal-detalhe-grafico/modal-detalhe-grafico-component';

import { SkeletonComponent } from './skeleton-component/skeleton-component';
import { PainelGeralComponent } from './painel-geral-component/painel-geral-component';
import { CardTotalizadoresComponent } from './card-totalizadores-component/card-totalizadores-component';
import { MapaComponent } from './mapa-component/mapa-component';
import { ChartPieComponent } from './chart-pie-component/chart-pie-component';
import { LegendasComponent } from './legendas-component/legendas-component';
import { ListaItensComponent } from './lista-itens-component/lista-itens-component';
import { ChartLineComponent } from './chart-line-component/chart-line-component';
import { ChartBarsComponent } from './chart-bars-component/chart-bars-component';
import { PainelSRAGComponent } from './painel-SRAG-component/painel-SRAG-component';
import { PainelInsumosComponent } from './painel-insumos-component/painel-insumos-component';
import { PainelLeitosComponent } from './painel-leitos-component/painel-leitos-component';
import { ListaSanfonaComponent } from './lista-sanfona-component/lista-sanfona-component';
import { PainelSobreComponent } from './painel-sobre-component/painel-sobre-component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    entryComponents: [
        ModalDetalheGraficoComponent,
    ],
    declarations: [
        ModalDetalheGraficoComponent,
        SkeletonComponent,
        PainelGeralComponent,
        PainelSRAGComponent,
        PainelInsumosComponent,
        PainelLeitosComponent,
        CardTotalizadoresComponent,
        MapaComponent,
        ChartPieComponent,
        LegendasComponent,
        ListaItensComponent,
        ChartLineComponent,
        ChartBarsComponent,
        ListaSanfonaComponent,
        PainelSobreComponent,

    ],
    exports: [
        ModalDetalheGraficoComponent,
        SkeletonComponent,
        PainelGeralComponent,
        PainelSRAGComponent,
        PainelLeitosComponent,
        PainelInsumosComponent,
        CardTotalizadoresComponent,
        MapaComponent,
        ChartPieComponent,
        LegendasComponent,
        ListaItensComponent,
        ChartLineComponent,
        ChartBarsComponent,
        ListaSanfonaComponent,
        PainelSobreComponent,

    ],
})

export class ComponentsModule {
    private static ModalCalendarComponent: any;
}
